import { Component, OnInit } from '@angular/core';
import { GlobalEventsManager } from '../../app-global-events-manager';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {

  constructor(private globalEventsManager: GlobalEventsManager) { }

  ngOnInit() {
    this.globalEventsManager.showNavBarSeller(false);
    this.globalEventsManager.showNavBarWorker(false);
    this.globalEventsManager.showNavBar(false);
  }

}



// WEBPACK FOOTER //
// ./src/app/authentication/not-found/not-found.component.ts